import { getBlockedFreeEmailValidationMessage } from '@/components/work-email-input/work-email-policy'

export function getOrganizationInviteEmailError(email: string, existingEmails: string[], currentUserEmail?: string | null): string | null {
  const trimmedEmail = email.trim()

  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail)) {
    return 'Invalid email'
  }

  const policyError = getBlockedFreeEmailValidationMessage(trimmedEmail)
  if (policyError) return policyError

  if (existingEmails.some((existingEmail) => existingEmail.toLowerCase() === trimmedEmail.toLowerCase())) {
    return 'Email already added'
  }

  if (trimmedEmail.toLowerCase() === currentUserEmail?.toLowerCase()) {
    return 'You cannot send an invitation to your own email address'
  }

  return null
}
